// extracted by mini-css-extract-plugin
export default {"circularProgressBox":"Search_circularProgressBox__Qi3YQ"};